














































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {Chart} from 'highcharts-vue';
import {getFormattedDate} from '@/utils/dateTimeUtils';
import {uuidv4} from '@u/uuidUtils';
import {WaterfallDiagramData} from './interfaces';
import Highcharts from 'highcharts';
import heatmap from 'highcharts/modules/heatmap';
import boost from 'highcharts/modules/boost';
import CursorDiagramToolbar from '@c/toolbar/CursorDiagramToolbar.vue';
import {CursorDiagramModeManager} from '@/logic/cursorDiagramModeManager';
import {DiagramMode, WaterfallSettings} from '@/interfaces/diagrams';
import {vibrationDiagramModes} from '@/logic/diagramModes';
import {DiagramModeType, DiagramZoomType, SpectrumEventType} from '@/enums/diagrams';
import {CursorLabelModel} from '@/logic/cursors/labelModels/cursorLabelModel';
import {CursorDiagramState} from '@/logic/cursorDiagramState';
import diagramStoreModule from '@/store/modules/signalDiagramModule';
import {vibrationDiagnosticsWaterfallDiagramSyncModes} from '@/components/toolbar/configurate';
import SyncMenuButton from '@c/toolbar/SyncMenuButton.vue';
import {DiagramSyncModeType} from '@/components/toolbar/enums';
import {spectrumYAxisTypes} from '@/api/configurate';
import WaterfallSettingsDialog from './WaterfallSettingsDialog.vue';

heatmap(Highcharts);
boost(Highcharts);

@Component({
  components: {
    highchart: Chart,
    CursorDiagramToolbar,
    SyncMenuButton,
    WaterfallSettingsDialog,
  },
})
export default class WaterfallDiagram extends Vue {
  skipZoom(updateState = true) {
    // TODO:
    if (this.modeManager.skipZoom(updateState)) this.$emit('skipZoom');
  }

  @Prop({required: true, default: {}})
  spectrumType!: SpectrumEventType;

  get isShowSettings() {
    return false;
    //убрал кнопку изменения настроек
    //return this.spectrumType === SpectrumEventType.Low;
  }

  // Настройки диаграммы
  settings: WaterfallSettings = {
    yAxisType: spectrumYAxisTypes[0],
  };

  @Watch('settings')
  onSpectrumYAxisChange(newValue: WaterfallSettings, oldValue: WaterfallSettings) {
    if (oldValue.yAxisType != newValue.yAxisType) {
      this.$emit('changeYAxisType', {value: newValue.yAxisType?.value, recalc: true});
    }
  }

  setSettings(newSettings: WaterfallSettings) {
    this.settings = {...newSettings};
    this.$emit('updateUserSettings', {...newSettings});
  }

  // Показатель активности тулбара для работы с графиком
  get toolbarDisabled() {
    return !this.chartData.data.length;
  }

  /*
    Показывать кнопку синхронизации
  */
  get showSyncButton() {
    return false;
  }

  // Идентификатор диаграммы
  id: string = uuidv4();

  // Режимы диаграммы
  diagramModes: DiagramMode[] = vibrationDiagramModes;

  // Предустановленные режимы
  preselectedModes: DiagramMode[] = [
    this.diagramModes.find(mode => mode.type === DiagramModeType.View) as DiagramMode,
  ];

  // Менеджер для работы с диаграммой
  modeManager: CursorDiagramModeManager = new CursorDiagramModeManager(
    null /* новый курсор будет HeatmapCursor вместо SimpleCursor */,
    new CursorLabelModel('', this.xCursorLabelFormatter),
    null,
    this.cursorApplyCallback,
    [],
    (() => {
      const state = new CursorDiagramState();
      state.diagramId = this.id;
      state.activeModes = this.preselectedModes;
      return state;
    })(),
  );

  xCursorLabelFormatter(value: any) {
    return getFormattedDate(value, 'HH:mm:ss (dd.MM)');
  }

  cursorApplyCallback() {
    if (this.syncApply) {
      const state = this.modeManager.getState();
      diagramStoreModule.diagramSync(state);
    }
  }

  @Prop({required: true, default: {}})
  chartData!: WaterfallDiagramData;

  //Ключ для обновления размеров диаграммы
  @Prop({required: false, type: Number, default: 0})
  resizedKey!: number;

  @Prop({required: false, type: Number, default: 0})
  minY!: number;

  @Prop({required: false, type: Number, default: 2000})
  maxY!: number;

  @Prop({required: false, type: Number, default: 1})
  rowsize!: number;

  @Prop({required: false, type: Number, default: 1})
  colsize!: number;

  // Минимальный масштаб по оси X
  @Prop({default: 0, type: Number})
  xMinScaleValue!: number;

  // Минимальный масштаб по оси Y
  @Prop({default: 0, type: Number})
  yMinScaleValue!: number;

  // Показатель того, что применен зум
  @Prop({required: false, type: Boolean, default: false})
  isInZoom!: boolean;

  @Prop({type: Number})
  xSoftMin!: number;

  @Prop({type: Number})
  xSoftMax!: number;

  @Watch('isInZoom')
  onChangeIsInZoom(value: any) {
    if (!value) this.modeManager.clearZoom();
  }

  @Watch('resizedKey')
  onResizedKeyChanged() {
    this.getChart().reflow();
  }

  // Идентификатор основной серии графика
  mainSeriesId = `mainSeries-${this.id}`;

  // Список идентификаторов графиков на диаграмме (нужно знать для подключения курсоров)
  chartSeriesIds: string[] = [this.mainSeriesId];

  get diagramStoreModule() {
    return diagramStoreModule;
  }

  get diagramSyncModes() {
    return vibrationDiagnosticsWaterfallDiagramSyncModes;
  }

  mounted() {
    const chart = this.getChart();
    this.modeManager.init(chart, this.chartSeriesIds, this.xMinScaleValue);
  }

  xFormatter(e: any) {
    return getFormattedDate(e.value, 'HH:mm:ss<br />(dd.MM.yyyy)');
  }

  get chartOptions() {
    return {
      chart: {
        type: 'heatmap',
        animation: false,
        events: {
          selection: this.onSelection,
          render: this.onRender,
          afterUpdate: this.afterUpdate,
        },
        zoomType: this.modeManager.zoomType,
      },
      credits: {
        enabled: false,
      },
      title: '',
      boost: {
        useGPUTranslations: true,
      },

      xAxis: {
        type: 'datetime',
        title: {
          text: 'Время',
        },
        labels: {
          formatter: this.xFormatter,
        },
        softMin: this.xSoftMin,
        softMax: this.xSoftMax,
      },

      yAxis: {
        title: {
          text: 'Частота, Гц',
        },
        minPadding: 0,
        maxPadding: 0,
        min: this.minY,
        max: this.maxY,
        tickWidth: 1,
        startOnTick: false,
        endOnTick: false,
      },

      colorAxis: {
        stops: [
          [0, '#3060cf'],
          [0.5, '#fffbbc'],
          [0.9, '#c4463a'],
          [1, '#c4463a'],
        ],
        min: this.chartData.minAmplitude,
        max: this.chartData.maxAmplitude,
        startOnTick: false,
        endOnTick: false,
      },

      series: [
        {
          id: this.mainSeriesId,
          data: this.chartData.data,
          boostThreshold: 100,
          borderWidth: 0,
          nullColor: '#EFEFEF',
          colsize: this.colsize,
          rowsize: this.rowsize,
          turboThreshold: Number.MAX_VALUE,
        },
      ],

      tooltip: {
        enabled: false,
      },
      navigation: {
        buttonOptions: {
          enabled: false,
        },
      },
    };
  }

  onRender() {
    // Некоторые действия, например отрисовку отметок на диагамме нужно делать на onRender
    // т. к. требуется перерисовка на любое изменение графика (например изменение размера)
    this.modeManager.renderActiveModes();
    const chart = this.getChart();
    if (chart && chart.resetZoomButton) {
      chart.resetZoomButton.hide();
    }
    this.$emit('rendered');
  }

  getChart() {
    return (this.$refs.chart as any).chart;
  }

  /*
    Действия при изменении статуса отображения линии курсора
  */
  changeShowCursorLine(show: boolean) {
    //Проводим изменения для текущего графика
    this.modeManager.showLine(show);
    //Если в режиме синхронизации, то отправляем другим графикам
    if (this.syncApply) diagramStoreModule.diagramSync(this.modeManager.getState());
  }

  /*
    Действия при изменении статуса отображения отметок курсора
  */
  changeShowCursorTooltips(show: boolean) {
    this.modeManager.showTooltips(show);
    if (this.syncApply) diagramStoreModule.diagramSync(this.modeManager.getState());
  }

  /*
    Выбор режима графика
  */
  selectModes(modes: DiagramMode[]) {
    this.modeManager.updateState([...modes]);
    if (this.syncApply) diagramStoreModule.diagramSync(this.modeManager.getState());
  }

  /*
    Показатель применения синхронизации к графику
  */
  get syncApply() {
    return this.chartData && diagramStoreModule.syncDiagrams.some(x => x.id === this.chartData.id);
  }

  @Watch('modeManager.changedZoomXKey')
  onChangeZoomXKey() {
    if (this.syncApply) diagramStoreModule.diagramSync(this.modeManager.getState());
  }

  /*
    Computed поле, привязанное к vuex и watcher для него
  */
  get sync() {
    return diagramStoreModule.sync;
  }
  @Watch('sync')
  syncChanged(sync: {syncModes: any[]; syncDiagrams: any[]; syncedState: CursorDiagramState}) {
    if (
      this.sync.syncModes.some(x => x.type === DiagramSyncModeType.ZoomX) &&
      this.modeManager.zoomType !== DiagramZoomType.X &&
      this.modeManager.zoomType !== DiagramZoomType.None
    ) {
      this.modeManager.zoomType = DiagramZoomType.X;
      this.skipZoom(false);
    }

    const value = sync.syncedState;

    //проверка на то, что это не данная диаграмма
    if (value && value.diagramId === this.id) {
      return;
    }
    const toolbar = this.getToolbar();

    if (value && sync.syncModes.some(x => x.type === DiagramSyncModeType.ZoomX)) {
      const state = new CursorDiagramState(value);
      state.diagramId = this.id;
      this.modeManager.patchZoomState(state, true);

      if (!value.selectedZoomXData?.active) this.skipZoom(false);
      else {
        let interval = value.selectedZoomXData.interval;
        if (!interval.dateInterval) {
          interval = {dateInterval: value.selectedZoomXData.interval, indexInterval: null};
        }
        this.$emit('zoom', interval);
      }
    }

    if (value) {
      //изменяем логику режимов
      const state = new CursorDiagramState(value);
      state.diagramId = this.id;
      this.modeManager.patchCursorState(state, true);
      this.modeManager.showLine(state.isShowLine);
      this.modeManager.showTooltips(state.isShowTooltips);
      this.modeManager.updateDiagram(state.isUpdateDiagram);
    }

    const syncedState = this.modeManager.getState();
    //изменяем представление
    toolbar.setupState(syncedState);
  }

  /*
    Действия после обновления графика - необходимо перерисовать
    все, что применено на график с режимов
    т. к. объект графика обновится
  */
  afterUpdate() {
    if (this.sync && diagramStoreModule.syncedState)
      this.modeManager.updateActiveModes(diagramStoreModule.syncedState, this.chartSeriesIds);
    else this.modeManager.updateActiveModes(this.modeManager.getState(), this.chartSeriesIds);
  }

  onSelection(e: any) {
    e.preventDefault();

    const intervals = this.modeManager.applyZoom(
      e.xAxis[0],
      e.yAxis[0],
      (
        xAxis: any,
        yAxis: any,
        chart: any,
        extremesX: any[],
        extremesY: any[],
        state: CursorDiagramState,
      ) => {
        let zoomY = null;
        let zoomX = null;
        // т.к. в запросе мы должны передавать  границы и по X, и по Y, то изначально берем текущие значения границ по обеим осям

        // Применяем зум по Y
        if (yAxis) {
          const lastExtremesY = extremesY.pop();

          if (lastExtremesY && lastExtremesY.minIndex) {
            zoomY = {startIndex: lastExtremesY.minIndex, endIndex: lastExtremesY.maxIndex};
          }

          const {minIndex, maxIndex} = this.getYIndeciesByExtreme(chart, yAxis.min, yAxis.max);
          if (minIndex && maxIndex && Math.abs(minIndex - maxIndex) >= this.yMinScaleValue) {
            extremesY.push({minIndex: minIndex, maxIndex: maxIndex});
            this.modeManager.isInYZoom = true;
            zoomY = {startIndex: minIndex, endIndex: maxIndex};
          }
        }

        // Применяем зум по X
        if (xAxis) {
          const lastExtremesX = extremesX.pop();

          if (lastExtremesX && lastExtremesX.min) {
            zoomX = {startDateTime: lastExtremesX.min, endDateTime: lastExtremesX.max};
          }

          const startDateTime = Math.round(xAxis.min);
          const endDateTime = Math.round(xAxis.max);
          if (Math.abs(startDateTime - endDateTime) > this.xMinScaleValue) {
            extremesX.push({min: xAxis.min, max: xAxis.max});
            zoomX = {startDateTime, endDateTime};
          }
        }

        if (zoomX || zoomY) {
          state.selectedZoomXData = {
            active: true,
            interval: {dateInterval: zoomX, indexInterval: zoomY},
          };
          this.modeManager.changedZoomXKey++;
          return {dateInterval: zoomX, indexInterval: zoomY};
        } else {
          state.selectedZoomXData = {active: false};
          this.modeManager.changedZoomXKey++;
          return null;
        }
      },
    );
    if (intervals) this.$emit('zoom', intervals);
  }

  getYIndeciesByExtreme(chart: any, min: any, max: any): {minIndex: any; maxIndex: any} {
    const startIndex = Math.round(min);
    const endIndex = Math.round(max);

    //Зум по данным, а не по области
    let minY = Number.MAX_VALUE;
    let maxY = 0;
    let minP: any = null;
    let maxP: any = null;

    const mainSeries = chart.get(this.mainSeriesId);
    mainSeries.points.forEach((p: any) => {
      if (p.y > startIndex && p.y < minY) {
        minY = p.y;
        minP = p;
      }
      if (p.y < endIndex && p.y > maxY) {
        maxY = p.y;
        maxP = p;
      }
    });

    if (minY === Number.MAX_VALUE || maxY === 0 || minY > maxY || !minP || !maxP)
      return {minIndex: null, maxIndex: null};
    const minIndex = minP.y;
    const maxIndex = maxP.y;
    return {minIndex, maxIndex};
  }

  getToolbar() {
    return this.$refs.cursorDiagramToolbar as any;
  }
}
